import { render, staticRenderFns } from "./HolidayPeriodsListPage.vue?vue&type=template&id=16cfce76&scoped=true&"
import script from "./HolidayPeriodsListPage.vue?vue&type=script&lang=ts&"
export * from "./HolidayPeriodsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayPeriodsListPage.vue?vue&type=style&index=0&id=16cfce76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cfce76",
  null
  
)

export default component.exports